import React from 'react';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import PartialBlockPortalList from '../Partials/PartialBlockPortalList';
import { processHTML } from '../On2Content.utils';
import { normalizeHtml } from '../../../lib/Pipes/pipes';
import { resolveResourceReferences } from '../../../_lib/components/Wysiwyg/utils/anchorUtils';

export type On2HtmlContainer = {
  html: string;
  resourceReferencesToToUrls: Record<string, { value: string }>;
  partialBlocks: any;
  ref?: React.RefObject<HTMLDivElement | null>;
};

export function On2HtmlContainer({ html, resourceReferencesToToUrls, partialBlocks, ref }: On2HtmlContainer) {
  const { t } = useTranslation();
  const location = useLocation();
  const processedHTML = processHTML(location, html, partialBlocks);

  const normalizedHtml = normalizeHtml(processedHTML, resolveResourceReferences(resourceReferencesToToUrls, t));

  return (
    <>
      {normalizedHtml && (
        <div
          className="wysiwyg"
          ref={ref}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: normalizedHtml,
          }}
        />
      )}
      {ref && (
        <PartialBlockPortalList
          partialBlocks={partialBlocks}
          partialBlockSelector="[data-replace-by={{key}}]"
          partialBlockSelectorKeyPlaceHolder="{{key}}"
          replaceIdentifier="data-unfunctional-partial-block"
          ref={ref}
        />
      )}
    </>
  );
}
